(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chromic-promo-popup"]) return;
  try {
    
if (!customElements.get('chromic-promo')) customElements.define('chromic-promo', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const dialog = this.querySelector('dialog');
    const copy = this.querySelector('[data-copy]');
    const status = this.querySelector('[role="status"]');
    const key = 'chromic-promo-seen-v1';
    let previousFocus;
    const close = () => dialog.close();
    this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
    dialog.addEventListener('close', () => { if (previousFocus?.isConnected) previousFocus.focus({preventScroll:true}); });
    copy.addEventListener('click', async () => {
      const code = copy.dataset.code;
      let copied = false;
      try { await navigator.clipboard.writeText(code); copied = true; } catch {
        const input = document.createElement('textarea'); input.value = code; input.style.cssText = 'position:fixed;opacity:0'; dialog.append(input); input.select();
        try { copied = document.execCommand('copy'); } catch {} input.remove(); copy.focus();
      }
      status.textContent = copied ? copy.dataset.success : this.querySelector('[data-copy-failure]').content.textContent;
      if (copied) copy.textContent = copy.dataset.success;
    });
    const claimButton=this.querySelector('[data-claim]');claimButton.addEventListener('click',()=>{const code=claimButton.dataset.code.toUpperCase();try{sessionStorage.setItem('chromic-free-delivery-code',code)}catch{}document.dispatchEvent(new CustomEvent('chromic:delivery-claimed',{detail:{code}}));claimButton.textContent=claimButton.dataset.success;status.textContent=claimButton.dataset.success;});let seen = false;
    try { seen = sessionStorage.getItem(key) === '1'; } catch {}
    if (this.dataset.editor !== 'true' && this.dataset.frequency !== 'page' && seen) return;
    const open = () => {
      if (!this.isConnected) return;
      if (document.visibilityState !== 'visible' || document.querySelector('dialog[open], [aria-modal="true"]:not([hidden])')) { this.timer = setTimeout(open, 1500); return; }
      previousFocus = document.activeElement; dialog.showModal();
      try { sessionStorage.setItem(key, '1'); } catch {}
    };
    this.timer = setTimeout(open, Number(this.dataset.delay) * 1000);
  }
  disconnectedCallback() { clearTimeout(this.timer); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
